import { Stack } from '@fluentui/react';
import React, { useEffect } from 'react';

// assets

import { useStore } from '../../../stores/root';
import OutcomeInvoicesList from '../../../components/finances/outcomes/invoices/general/list';
import { faHome } from '@fortawesome/pro-light-svg-icons';

interface IOutcomeInvoicesPageProps {
}

const OutcomeInvoicesPage: React.FC<IOutcomeInvoicesPageProps> = (props: IOutcomeInvoicesPageProps) => {
    const {topbar} = useStore();

    useEffect(() => {
        topbar.show("Outcome Invoices", [
            {key: "home", icon: faHome, href: "/"},
            {key: "finance", text: 'Finance', href: "/finance"},
            {key: "outcomes", text: 'Outcomes', href: "/finance/outcomes"},
            {key: "outcomeInvoices", text: 'Invoices'}
        ])
    }, []);

    return <Stack>
        <OutcomeInvoicesList />
    </Stack>;
};

export default OutcomeInvoicesPage;
